<template>
  <div class="activity-apply">
    <!-- 活动信息 -->
    <div class="apply-info">
      <van-cell-group>
        <van-field
          v-model="promotionData.name"
          label="活动名称"
          placeholder="填写活动名称"
        />
        <van-field
          v-model="promotionData.shareTitle"
          label="分享标题"
          placeholder="填写分享给朋友圈或好友的标题"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="promotionData.startTime"
          label="开始时间"
          placeholder="填写活动开始时间"
          @click="handlePicker('time', 'startTime')"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="promotionData.endTime"
          label="结束时间"
          placeholder="填写活动结束时间"
          @click="handlePicker('time', 'endTime')"
        />
        <van-field
          class="activity-rules"
          v-model="promotionData.rule"
          rows="5"
          autosize
          label=""
          type="textarea"
          placeholder="请填写活动规则，包括优惠券使用规则、门店地址、到店激活时间等信息。"
          maxlength="500"
        />
        <div class="uploader">
          <van-uploader
            v-model="fileList"
            multiple
            :max-count="6"
            :after-read="afterRead"
            :before-delete="beforeDelete"
            :before-read="beforeRead"
            :preview-options="{ closeable: true }"
          />
        </div>
      </van-cell-group>
    </div>
    <!-- 套餐信息 -->
    <div class="combo-info">
      <van-cell-group>
        <van-field
          type="number"
          v-model="price"
          label="活动套餐价格"
          placeholder="填写活动套餐价格"
        >
          <!-- <template #extra>
            <van-checkbox v-model="promotionData.isDeposit">定金</van-checkbox>
          </template> -->
        </van-field>
        <van-field
          right-icon="arrow"
          readonly
          clickable
          name="picker"
          value=""
          label="从默认设置里选择"
          @click="handlePicker('activityItem')"
        />
        <van-row class="combo-item-title">
          <van-col span="5">项目</van-col>
          <van-col span="5">单价</van-col>
          <van-col span="5">数量</van-col>
          <van-col span="5">单位</van-col>
          <van-col span="4">操作</van-col>
        </van-row>
        <van-row
          class="combo-item"
          v-for="(item, index) in serviceItems"
          :key="index"
        >
          <van-col span="5">
            <van-field v-model="item.itemName" placeholder="项目" />
          </van-col>
          <van-col span="5">
            <van-field
              type="number"
              v-model="item.unitPrice"
              placeholder="单价"
            />
          </van-col>
          <van-col span="5">
            <van-field
              maxlength="2"
              type="number"
              v-model="item.quantity"
              placeholder="数量"
            />
          </van-col>
          <van-col span="5">
            <van-field v-model="item.unit" placeholder="单位" />
          </van-col>
          <van-col span="4" class="clear-item">
            <van-icon name="clear" @click="handleClear(index)" />
          </van-col>
        </van-row>
        <van-button type="info" class="add-item" @click="handleAddComboItem">
          增加项目
        </van-button>
      </van-cell-group>
    </div>
    <!-- 激活设置 -->
    <div class="active-setting">
      <van-cell-group>
        <van-field
          readonly
          clickable
          name="picker"
          :value="promotionData.activateStartTime"
          label="激活开始时间"
          placeholder="填写激活开始时间"
          @click="handlePicker('time', 'activateStartTime')"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="promotionData.activateEndTime"
          label="激活截止时间"
          placeholder="填写激活截止时间"
          @click="handlePicker('time', 'activateEndTime')"
        />
      </van-cell-group>
    </div>
    <!-- 主流程按钮 -->
    <div class="process-btn">
      <van-button color="#7232dd" @click="handleToPublicity">
        预览效果
      </van-button>
      <van-button type="primary" @click="handleIssue" :loading="subStatus">
        保存修改
      </van-button>
    </div>
    <!-- 时间选择 -->
    <van-popup v-model="datePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="handleDate"
        @cancel="datePicker = false"
      />
    </van-popup>
    <!-- 活动项选择 -->
    <van-popup v-model="activityItemPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="defaultItem"
        @confirm="handleActivityItem"
        @cancel="activityItemPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { activityEdit, serviceItem } from "@/api/activity";
import * as imageConversion from "image-conversion";
import { Dialog } from "vant";
export default {
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      datePicker: false,
      dateTag: "",
      activityItemPicker: false,
      fileList: [],
      promotionData: {
        name: "",
        shareTitle: "",
        startTime: "",
        endTime: "",
        rule: "",
        pics: [],
        price: "",
        serviceItems: [],
        activateStartTime: "",
        activateEndTime: "",
        isDeposit: false
      },
      price: "",
      serviceItems: [],
      defaultItem: [],
      subStatus: false
    };
  },
  mounted() {
    this.promotionData = JSON.parse(localStorage.getItem("editData"));
    this.serviceItems = this.promotionData.serviceItems;
    this.price = this.promotionData.price;
    this.promotionData.pics.forEach(val => {
      this.fileList.push({
        url: this.$imgPath + val
      });
    });
    this.handleServiceItem();
  },
  methods: {
    // 选择器处理
    handlePicker(type, tag) {
      if (type === "time") {
        this.datePicker = true;
        switch (tag) {
          case "startTime":
            this.dateTag = "startTime";
            break;
          case "endTime":
            this.dateTag = "endTime";
            break;
          case "activateStartTime":
            this.dateTag = "activateStartTime";
            break;
          case "activateEndTime":
            this.dateTag = "activateEndTime";
            break;
          default:
            break;
        }
      } else {
        this.activityItemPicker = true;
      }
    },
    // 时间选择
    handleDate(date) {
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = date.getFullYear() + "-" + m + "-" + d;
      switch (this.dateTag) {
        case "startTime":
          this.promotionData.startTime = timer;
          break;
        case "endTime":
          this.promotionData.endTime = timer;
          break;
        case "activateStartTime":
          this.promotionData.activateStartTime = timer;
          break;
        case "activateEndTime":
          this.promotionData.activateEndTime = timer;
          break;
        default:
          break;
      }
      this.datePicker = false;
    },
    // 活动项目选择
    handleActivityItem(value) {
      this.activityItemPicker = false;
      this.serviceItems.push({
        itemName: value.text,
        unitPrice: value.unitPrice,
        quantity: value.quantity,
        unit: value.unit
      });
    },
    // 上传图片前
    beforeRead(file) {
      return new Promise(resolve => {
        const isLt2M = file.size / 1024 < 300;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 300).then(res => {
            let files = new window.File([res], file.name, {
              type: file.type
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      this.$api
        .uploadImg(data)
        .then(res => {
          file.status = "done";
          file.message = "上传成功";
          this.promotionData.pics.push(res.url);
        })
        .catch(err => {
          console.log(err);
          this.fileList.splice(this.fileList.length - 1, 1);
          this.$toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete(file, detail) {
      this.fileList.splice(detail.index, 1);
      this.promotionData.pics.splice(detail.index, 1);
    },
    // 默认套餐项目
    handleServiceItem() {
      serviceItem().then(res => {
        // console.log("默认套餐项目:", res);
        res.forEach(val => {
          val.text = val.itemName;
          val.unitPrice = val.unitPrice / 100;
        });
        this.defaultItem = res;
      });
    },
    // 增加套餐项目
    handleAddComboItem() {
      let itemInfo = {
        itemName: "",
        unitPrice: "",
        quantity: "",
        unit: ""
      };
      this.serviceItems.push(itemInfo);
    },
    // 清除项目
    handleClear(index) {
      // console.log(index);
      this.serviceItems.splice(index, 1);
    },
    // 申请发布
    handleIssue() {
      this.subStatus = true;
      if (!this.handleFormVerify()) {
        this.subStatus = false;
        return;
      }
      this.promotionData.serviceItems = this.serviceItems;
      this.promotionData.price = parseFloat(this.price);
      if (/^([0-9]{1,}[.][0-9]*)$/.test(this.promotionData.price)) {
        this.promotionData.price = (
          this.promotionData.price.toFixed(2) * 100
        ).toFixed();
      } else {
        this.promotionData.price = this.promotionData.price * 100;
      }
      activityEdit(this.promotionData).then(res => {
        this.subStatus = false;
        // console.log("申请发布:", res);
        if (res.code === 0) {
          Dialog.alert({
            title: "提示",
            message: "修改成功"
          }).then(() => {
            localStorage.removeItem("editData");
            this.$router.push("/");
          });
        }
      });
    },
    // to预览
    handleToPublicity() {
      if (!this.handleFormVerify()) {
        this.subStatus = false;
        return;
      }
      this.promotionData.serviceItems = this.serviceItems;
      this.promotionData.price = parseFloat(this.price);
      if (/^([0-9]{1,}[.][0-9]*)$/.test(this.promotionData.price)) {
        this.promotionData.price = this.promotionData.price.toFixed(2);
      }
      localStorage.setItem("editData", JSON.stringify(this.promotionData));
      this.$router.push("/activity/publicity");
    },
    // 表单校验
    handleFormVerify() {
      let serviceItemsRules = false;
      this.serviceItems.forEach(val => {
        for (const key in val) {
          if (val[key].trim() === "") {
            serviceItemsRules = true;
          }
        }
      });
      if (!/[\u4e00-\u9fa5]/gm.test(this.promotionData.name.trim())) {
        this.$toast("活动名称请输入中文");
        return false;
      }
      if (!/[\u4e00-\u9fa5]/gm.test(this.promotionData.shareTitle.trim())) {
        this.$toast("分享标题请输入中文");
        return false;
      }
      if (this.promotionData.startTime.trim() === "") {
        this.$toast("请填写活动开始时间");
        return false;
      }
      if (this.promotionData.endTime === "") {
        this.$toast("请填写活动结束时间");
        return false;
      }
      if (this.promotionData.rule.trim() === "") {
        this.$toast("请填写活动规则");
        return false;
      }
      if (this.promotionData.pics.length === 0) {
        this.$toast("请上传门店图片");
        return false;
      }
      if (!this.price) {
        this.$toast("请填写活动套餐价格");
        return false;
      }
      if (this.serviceItems.length === 0) {
        this.$toast("请填写活动项目");
        return false;
      }
      if (serviceItemsRules) {
        this.$toast("活动项目内容不得为空");
        return false;
      }
      if (this.promotionData.activateStartTime.trim() === "") {
        this.$toast("请填写激活开始时间");
        return false;
      }
      if (this.promotionData.activateEndTime === "") {
        this.$toast("请填写激活截止时间");
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-apply {
  .apply-info {
    border-bottom: 5px solid #eaeaea;
  }

  .combo-info {
    border-bottom: 5px solid #eaeaea;

    .combo-item-title {
      padding-top: 16px;
      padding-left: 10px;
    }

    .combo-item {
      padding-top: 10px;
      padding-left: 10px;

      .clear-item {
        .van-icon {
          top: 4px;
          color: red;
        }
      }
    }

    .add-item {
      height: 30px;
      margin-top: 16px;
      margin-bottom: 16px;
      line-height: 30px;
    }
  }

  .process-btn {
    display: flex;
    justify-content: space-around;
    margin-top: 16px;
  }
}
</style>
<style lang="scss">
.activity-apply {
  .apply-info {
    .uploader {
      padding: 10px 16px;
      padding-left: 30px;
      text-align: left;
    }

    .activity-rules {
      padding-left: 30px;

      .van-field__value {
        border: 1px solid #ebedf0;
      }

      .van-field__control {
        padding: 10px;
      }
    }
  }

  .combo-info {
    .van-cell {
      padding-left: 30px;
    }

    .van-field__label {
      width: 130px;
      text-align: left;
    }

    .combo-item {
      .van-cell {
        padding: 0;
      }

      .van-field__control {
        text-align: center;
      }
    }
  }

  .active-setting {
    .van-cell {
      padding-left: 30px;
    }

    .van-field__label {
      width: 130px;
      text-align: left;
    }
  }
}
</style>
